export const TEST_TENANT_EMAIL_SETTINGS_MUTATION = `
  mutation ($settings: EmailSettingsArgs!){
    testTenantEmailSettings(settings: $settings)
  }
`;

export type testTenantEmailSettings = {
  testTenantEmailSettings: boolean
};
